import * as lib from '../api/me';
import { fetchLoadable } from '../fetchLoadable';
import * as actionTypes from './actionTypes';
export const get = () => fetchLoadable(actionTypes.FETCH_ME, lib.get);
export const update = (user) => lib.update(user).then(() => get());
//# sourceMappingURL=actions.js.map